/**
 * Checks if the provided value is an array.
 *
 * @param value - The value to check.
 * @returns True if the value is an array, otherwise false.
 */
export const isArray = <T>(value: unknown): value is T[] =>
  Array.isArray(value);
